// extracted by mini-css-extract-plugin
export default {"btn_style":"mainButtonGroup_btn_style__A4bYe","btn_sm_hide":"mainButtonGroup_btn_sm_hide__yoFm4","btn_span":"mainButtonGroup_btn_span__Hu+Wc"};